import type { IconProps } from '../types/IconProps.ts';
export const WalletCards: IconProps = {
    name: 'WalletCards',
    children: [
        `<path d="M21 9H5a2 2 0 1 1 0-4h4M21 13V9" />`,
        `<path d="M21 16.63V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7" />`,
        `<path d="M17 15c0-1.1.9-2 2-2h2.93q.06 0 .07.07v3.86q0 .06-.07.07H19a2 2 0 0 1-2-2M18.5 9.04l.26-.26a2 2 0 0 0 0-2.83l-3.53-3.54a2 2 0 0 0-2.83 0L5.8 9M10.59 9.17l5.65-5.66" />`,
    ]
};